import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginStatusService {

  // 当前页面是否由小程序跳转
  public isMiniProgram: boolean = false

}
